import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { BreadcrumbComponent, ButtonComponent, type BreadcrumbItem } from '../../shared/ui';
import { AuthModalService } from '../../shared/services/auth-modal.service';
import { AuthService } from '../../shared/services/auth.service';
import { ProfileHeaderComponent } from './components/profile-header/profile-header.component';
import { ProfileTabsComponent } from './components/profile-tabs/profile-tabs.component';
import { PROFILE_COPY } from './profile.copy';

/**
 * Contenedor de `/perfil` (B10): migas, cabecera del perfil (W0b), barra de pestañas y `<router-outlet>`; cada
 * pestaña es una ruta hija (`profile.routes.ts`). Con sesión, el `h1` es el nombre de la cuenta (lo pone la
 * cabecera); el del contenedor solo existe en la rama sin sesión.
 *
 * Sin guard (B27): sin sesión pinta «Inicia sesión…» con el botón al modal de login, y en cuanto la sesión
 * existe pasa a las pestañas sin recargar ni navegar, porque la plantilla lee `isAuthenticated()`. Si la
 * sesión cae con la página abierta, vuelve a la rama sin sesión por el mismo camino.
 */
@Component({
  selector: 'app-profile-page',
  imports: [BreadcrumbComponent, ButtonComponent, ProfileHeaderComponent, ProfileTabsComponent, RouterOutlet],
  templateUrl: './profile-page.component.html',
  styleUrl: './profile-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class ProfilePageComponent {
  private readonly authModal = inject(AuthModalService);
  private readonly auth = inject(AuthService);
  protected readonly isAuthenticated = this.auth.isAuthenticated;
  protected readonly currentUser = this.auth.currentUser;

  protected readonly copy = PROFILE_COPY;
  protected readonly breadcrumbs: BreadcrumbItem[] = [
    { label: PROFILE_COPY.BREADCRUMB_HOME, route: '/' },
    { label: PROFILE_COPY.BREADCRUMB_PROFILE, route: null },
  ];

  protected openLogin(): void {
    this.authModal.open('login');
  }
}
